import { FC } from 'react';
import { useCoresPainel } from '@/components/paineis/chartTheme';
import PainelShell from '@/components/paineis/PainelShell';
import PainelSop from '@/components/paineis/sop/PainelSop';
import { usePainelFiltrado } from '@/hooks/usePainelFiltrado';
import { dashboardsService } from '@/services/dashboards.service';
import type { SopPayload } from '@/types/dashboards';

const buscarSop = (params: Record<string, string>) => dashboardsService.getEquiplexSop(params);

/**
 * Painel "S&OP & Desvios de Produção" da Equiplex (`/paineis/equiplex/sop`).
 *
 * Lê o último snapshot gravado pelo backend — a réplica do Datasul só é consultada
 * no agendamento das 06:00 ou no "Atualizar agora" (ADMIN). Nenhuma planilha entra:
 * programado vem das OPs, produzido do reportado nessas OPs (CP0511 sem reprocesso) e faturado das notas fiscais.
 * Período e produto vêm do filtro dos painéis (na URL), aplicado no servidor.
 */
const EquiplexSopPage: FC = () => {
  const cores = useCoresPainel();
  const { estado, barra } = usePainelFiltrado<SopPayload>(buscarSop);
  return (
    <PainelShell
      estado={estado}
      prefixo="sop"
      origem="sop"
      titulo="S&OP e desvios de produção"
      subtitulo="Programado nas OPs × produzido reportado nelas × faturado, por mês de produção (dia 16 ao dia 15)."
      corte={(p) => p.corte}
    >
      {({ id, payload }) => (
        <>
          {barra(payload.recorte, undefined, payload.frescor?.dados_ate)}
          <PainelSop key={id} payload={payload} cores={cores} />
        </>
      )}
    </PainelShell>
  );
};

export default EquiplexSopPage;
